var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.747 23.313a6.672 6.672 0 01-6.673 6.67 6.672 6.672 0 110-13.343 6.673 6.673 0 016.673 6.673zM16.64 47.999v-6.96a6.024 6.024 0 016.024-6.023H41.87a6.024 6.024 0 016.024 6.023V48"
  })))));
};
export default SvgUser;